
export const GetCurrentUser = () => {
    const userString = localStorage.getItem("user");
    let fetchedUserName = "Guest";

    if (userString) {
        try {
            const userObject = JSON.parse(userString);
            const username = JSON.parse(userObject)
            fetchedUserName = username.name;
        } catch (error) {
            console.error("Error parsing JSON:", error);
        }
    } else {
        console.log("User data not found in localStorage.");
    }
    return fetchedUserName
}